import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import ServerList from './servers/ServerList';
import ServerForm from './servers/ServerForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addServersAction } from '../../actions/serversActions';
//Función principal
const Servers = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addServersAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Servidores' 
                subtitle='Sistema' 
                nodes={nodes}
                actions={actions}
                component={ServerList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <ServerForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Servers;